import React, { useEffect, useMemo, useState } from "react";
import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    ListItemText,
    MenuItem,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { GlobalState } from "context/GlobalContext";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import { AuthState } from "context/AuthContext";
import { roleAccess } from "../DiscountMasterList";
import { Discount_Master_store_Brands, DISOUNT_MASTER_CHANNEL_OPTIONS } from "../data";

const initialFormData = {
    channel: "",
    approver_mail: [],
    other_mail: [],
};

const compactSelectMenuProps = {
    PaperProps: {
        sx: {
            mt: 0.5,
            borderRadius: 1.5,
            boxShadow: "0 8px 24px rgba(16,24,40,0.12)",
            border: "1px solid #e4e7ec",
            "& .MuiMenuItem-root": {
                minHeight: 32,
                fontSize: "11px",
                py: 0.5,
            },
            "& .MuiListItemText-primary": {
                fontSize: "11px",
            },
        },
    },
};

function EmailChipField({
    label,
    value,
    inputValue,
    helperText,
    error,
    onInputChange,
    onCommit,
    onChange,
}) {
    const commitInput = (rawValue) => {
        if (!String(rawValue || "").trim()) return;
        onCommit(rawValue);
        onInputChange("");
    };

    return (
        <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={value || []}
            inputValue={inputValue}
            onInputChange={(_, nextValue, reason) => {
                if (reason === "reset") return;
                onInputChange(nextValue);
            }}
            onBlur={() => commitInput(inputValue)}
            onChange={(_, nextValue, reason) => {
                if (reason === "createOption" || reason === "blur") return;
                onChange(
                    nextValue
                        .map((item) => String(item).trim().toLowerCase())
                        .filter(Boolean)
                );
            }}
            renderTags={(tags, getTagProps) =>
                tags.map((option, index) => (
                    <Chip
                        {...getTagProps({ index })}
                        key={`${option}-${index}`}
                        label={option}
                        size="small"
                        variant="outlined"
                    />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    size="small"
                    helperText={helperText}
                    error={error}
                    inputProps={{
                        ...params.inputProps,
                        onKeyDown: (event) => {
                            if (
                                (event.key === "Enter" || event.key === "," || event.key === "Tab") &&
                                String(inputValue || "").trim()
                            ) {
                                event.preventDefault();
                                event.stopPropagation();
                                commitInput(inputValue);
                                return;
                            }
                            params.inputProps.onKeyDown?.(event);
                        },
                    }}
                    sx={{
                        "& .MuiInputBase-root": {
                            fontSize: "11px",
                            minHeight: 34,
                            maxHeight: 180,
                            overflowY: "auto",
                            alignItems: "flex-start",
                        },
                        "& .MuiInputLabel-root": { fontSize: "11px" },
                        "& .MuiFormHelperText-root": { fontSize: "10px", ml: 0 },
                    }}
                />
            )}
        />
    );
}

function ApprovalMAster() {
    const [formData, setFormData] = useState(initialFormData);
    const [approvalRows, setApprovalRows] = useState([]);
    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [emailInput, setEmailInput] = useState("");
    const [otherInput, setOtherInput] = useState("");
    const [showEmailError, setShowEmailError] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [selectedBrand, setselectedBrand] = useState([]);

    const { user } = AuthState();
    const roleData = roleAccess(user);
    console.log("Sxnaksdjbjkasvbc", roleData)
    const role = ["VIEWER"].includes(roleData.roles);
    const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

    const channelOptions = useMemo(
        () =>
            DISOUNT_MASTER_CHANNEL_OPTIONS.filter((item) =>
                roleData?.channelList?.includes(item.key)
            ),
        [roleData]
    );

    const brandOptions = useMemo(
        () =>
            Discount_Master_store_Brands.filter((item) =>
                roleData?.brandList?.includes(item.key)
            ),
        [roleData]
    );
    const brandOptionKeys = useMemo(() => brandOptions.map((item) => item.key), [brandOptions]);

    const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);
    const invalidEmailExists = formData.approver_mail.some((mail) => !isValidEmail(mail));

    const handleGetApprovalData = async () => {
        try {
            setLoadingOpen(true);
            let body = {
                    brand: roleData?.brandList,
                    channel: roleData?.channelList,
                };
            pythonVmInstance
                        .post("/discount-master/approvals", body)
            .then((res) => {
                 setApprovalRows(res?.data || []);
                 setLoadingOpen(false);
            })
        } catch (err) {
            const message = err?.response?.data?.message;
            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: message || "Unable to fetch approval master data",
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
        }
    };

    useEffect(() => {
        handleGetApprovalData();
    }, []);

    const handleChange = (field) => (e) => {
        setFormData((prev) => ({
            ...prev,
            [field]: e.target.value,
        }));
    };

    const handleOpenDialog = () => {
        setFormData(initialFormData);
        setEmailInput("");
        setOtherInput("");
        setShowEmailError(false);
        setEditingRow(null);
        setOpenAddDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenAddDialog(false);
        setEditingRow(null);
        setFormData(initialFormData);
        setEmailInput("");
        setOtherInput("");
        setselectedBrand([]);
        setShowEmailError(false);
    };

    const toList = (value) => {
        if (Array.isArray(value)) return value.filter(Boolean).map((item) => String(item).trim());
        if (!value || value === "-") return [];
        return String(value)
            .split(",")
            .map((item) => item.trim())
            .filter(Boolean);
    };

    const handleOpenEditDialog = (row) => {
        const channel = row?.channel || row?.Channel || "";
        const brands = toList(row?.brand || row?.Brand || []);
        const emails = toList(row?.approver_email || row?.approver_mail || row?.approver_mail || []).map(
            (item) => item.toLowerCase()
        );

        setFormData({
            ...row,
            channel,
            approver_mail: emails,
            other_mail: toList(row?.other_mail || []).map((item) => item.toLowerCase()),
        });
        setselectedBrand(brands);
        setEmailInput("");
        setOtherInput("");
        setShowEmailError(false);
        setEditingRow(row);
        setOpenAddDialog(true);
    };

    const parseEmails = (rawValue) =>
        String(rawValue || "")
            .split(/[,\s;]+/)
            .map((item) => item.trim().toLowerCase())
            .filter(Boolean);

    const appendEmails = (field, rawValue) => {
        const parsed = parseEmails(rawValue);
        if (!parsed.length) return;

        setFormData((prev) => ({
            ...prev,
            [field]: [...new Set([...(prev[field] || []), ...parsed])],
        }));
    };

    const handleSave = async () => {
        const approverEmails = [
            ...new Set([...(formData.approver_mail || []), ...parseEmails(emailInput)]),
        ];
        const otherEmails = [
            ...new Set([...(formData.other_mail || []), ...parseEmails(otherInput)]),
        ];

        const payload = {
            channel: formData.channel.trim(),
            brand: selectedBrand || [],
            approver_email: approverEmails,
            other_mail: otherEmails,
            email: user?.email,
        };
        const approvalMasterId = editingRow?.id || editingRow?._id;
        if (approvalMasterId !== undefined && approvalMasterId !== null) {
            payload.id = approvalMasterId;
        }

        if (!payload.channel || !selectedBrand.length || !payload.approver_email.length) {
            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: "Please fill all required fields",
                severity: "warning",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
            return;
        }
        if (!payload.approver_email.every((mail) => isValidEmail(mail))) {
            setShowEmailError(true);
            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: "Please enter valid approver emails",
                severity: "warning",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
            return;
        }
        const alreadyExists = approvalRows.some(
            (row) => row?.brand === payload.brand && row?.channel === payload.channel
        );

        if (alreadyExists) {
            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: "Approval master data with same channel and brand already exists",
                severity: "warning",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
            return; // ✅ This exits your function
        }

        try {
            setLoadingOpen(true);
            if (editingRow) {
                await pythonVmInstance.post("/discount-master/approval-master", payload, {
                    headers: { "Content-Type": "application/json" },
                });
            } else {
                await pythonVmInstance.post("/discount-master/approval-master", payload, {
                    headers: { "Content-Type": "application/json" },
                });
            }

            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: editingRow
                    ? "Approval master data updated successfully"
                    : "Approval master data saved successfully",
                severity: "success",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });

            setOpenAddDialog(false);
            setFormData(initialFormData);
            handleCloseDialog()
            setEditingRow(null);
            handleGetApprovalData();
            setLoadingOpen(false);
        } catch (err) {
            const message = err?.response?.data?.message;
            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: message || "Unable to save approval master data",
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
            setLoadingOpen(false);
        }
    };

    return (
        <Stack width="100%" p={1.5} spacing={1.25}>
            <Box display="flex" justifyContent="flex-end" alignItems="center">

                <Button
                    variant="contained"
                    onClick={handleOpenDialog}
                    disabled={role}
                    sx={{ minHeight: 30, fontSize: "10px", px: 1.5, textTransform: "none", borderRadius: "7px" }}
                >
                    Add Approver
                </Button>
            </Box>

            <TableContainer
                component={Paper}
                sx={{
                    height: "fit-content",
                    minHeight: 140,
                    borderRadius: "8px",
                    border: "1px solid #e4e7ec",
                    boxShadow: "0 1px 2px rgba(16,24,40,0.06)",
                }}
            >
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 700, minWidth: "120px", fontSize: "10px", py: 1, background: "#f8fafc" }}>Channel</TableCell>
                            <TableCell sx={{ fontWeight: 700, minWidth: "150px", fontSize: "10px", py: 1, background: "#f8fafc" }}>Brand</TableCell>
                            <TableCell sx={{ fontWeight: 700,minWidth: "180px", fontSize: "10px", py: 1, background: "#f8fafc" }}>Publisher Emails</TableCell>
                            <TableCell sx={{ fontWeight: 700,minWidth: "180px", fontSize: "10px", py: 1, background: "#f8fafc" }}>Other Emails</TableCell>
                            <TableCell sx={{ fontWeight: 700, width: 100, minWidth: "90px", fontSize: "10px", py: 1, background: "#f8fafc" }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {approvalRows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={5} align="center" sx={{ fontSize: "10px", py: 1.5 }}>
                                    No approval master data found
                                </TableCell>
                            </TableRow>
                        ) : (
                            approvalRows.map((row, idx) => {
                                const channel = row?.channel || row?.Channel || "-";
                                const rawBrand = row?.brand || row?.Brand || [];
                                const rawApproverEmail =
                                    row?.approver_email || row?.approver_mail || [];
                                const otherEmail =
                                    row?.other_mail || [];
                                const brand = Array.isArray(rawBrand) ? rawBrand : toList(rawBrand);
                                const approver_mail = Array.isArray(rawApproverEmail)
                                    ? rawApproverEmail
                                    : toList(rawApproverEmail);
                                const other_mail = Array.isArray(otherEmail)
                                    ? otherEmail
                                    : toList(otherEmail);

                                return (
                                    <TableRow key={`${channel}-${idx}`} hover>
                                        <TableCell sx={{minWidth: "120px", fontSize: "10px", py: 0.75}}>{channel}</TableCell>
                                        <TableCell sx={{minWidth: "150px", py: 0.75}}>
                                            {brand.map((b)=>(
                                                <Chip label={b} sx={{margin: "2px", fontSize: "10px", height: 20}} size="small" />
                                            ))}
                                        </TableCell>
                                        <TableCell sx={{minWidth: "180px", py: 0.75}}>
                                            <Stack direction="row" flexWrap="wrap" gap={0.5}>
                                                {approver_mail.length ? (
                                                    approver_mail.map((item, eIdx) => (
                                                        <Chip key={`${item}-${eIdx}`} label={item} size="small" variant="outlined" sx={{ fontSize: "10px", height: 20 }} />
                                                    ))
                                                ) : (
                                                    <Typography variant="caption" sx={{ fontSize: "10px" }}>-</Typography>
                                                )}
                                            </Stack>
                                        </TableCell>
                                        <TableCell sx={{minWidth: "180px", py: 0.75}}>
                                            <Stack direction="row" flexWrap="wrap" gap={0.5}>
                                                {other_mail.length ? (
                                                    other_mail.map((item, eIdx) => (
                                                        <Chip key={`${item}-${eIdx}`} label={item} size="small" variant="outlined" sx={{ fontSize: "10px", height: 20 }} />
                                                    ))
                                                ) : (
                                                    <Typography variant="caption" sx={{ fontSize: "10px" }}>-</Typography>
                                                )}
                                            </Stack>
                                        </TableCell>
                                        <TableCell sx={{minWidth: "90px", py: 0.75}}>
                                            <Button
                                                variant="contained"
                                                size="small"
                                                startIcon={<EditIcon fontSize="small" />}
                                                disabled={role}
                                                onClick={() => handleOpenEditDialog(row)}
                                                sx={{ minHeight: 26, fontSize: "10px", px: 1.25, textTransform: "none", borderRadius: "7px" }}
                                            >
                                                Edit
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={openAddDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
                <DialogTitle sx={{ fontSize: "14px", fontWeight: 700 }}>
                    {editingRow ? "Edit Approval Master" : "Add Approval Master"}
                </DialogTitle>
                <DialogContent>
                    <Stack spacing={1.5} mt={1}>
                        <TextField
                            select
                            label="Channel"
                            size="small"
                            disabled={editingRow}
                            value={formData.channel}
                            onChange={handleChange("channel")}
                            sx={{
                                "& .MuiInputBase-root": { fontSize: "11px", minHeight: 34, borderRadius: "8px", background: "#fff" },
                                "& .MuiInputLabel-root": { fontSize: "11px" },
                            }}
                            SelectProps={{
                                MenuProps: compactSelectMenuProps,
                            }}
                        >
                            {channelOptions.map((item) => (
                                <MenuItem key={item.key} value={item.key}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            select
                            size="small"
                            label="Select Discount to Apply"
                            disabled={editingRow}
                            value={selectedBrand}
                            onChange={(event) => setselectedBrand(event.target.value)}
                            sx={{
                                flex: 1,
                                minWidth: 250,
                                "& .MuiInputBase-root": { fontSize: "11px", minHeight: 34, borderRadius: "8px", background: "#fff" },
                                "& .MuiInputLabel-root": { fontSize: "11px" },
                            }}
                            SelectProps={{
                                multiple: true,
                                MenuProps: compactSelectMenuProps,
                                renderValue: (selected) => 
                                    brandOptions
                                        .filter(opt => selected.includes(opt.key))
                                        .map(opt => opt.name)
                                        .join(", ")
                            }}
                        >
                            {brandOptions.map((item) => (
                                <MenuItem key={item.key} value={item.key}>
                                    <Checkbox checked={selectedBrand.indexOf(item.key) > -1} size="small" sx={{ p: 0.5, mr: 0.5 }} />
                                    <ListItemText primary={item.name} />
                                </MenuItem>
                            ))}
                        </TextField>
                        <EmailChipField
                            label="Approver Email"
                            value={formData.approver_mail}
                            inputValue={emailInput}
                            error={showEmailError && invalidEmailExists}
                            onInputChange={setEmailInput}
                            onCommit={(rawValue) => appendEmails("approver_mail", rawValue)}
                            onChange={(nextValue) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    approver_mail: nextValue,
                                }))
                            }
                        />
                        <EmailChipField
                            label="Other Email"
                            value={formData.other_mail}
                            inputValue={otherInput}
                            helperText="Type email and press Enter/Comma/Tab"
                            error={showEmailError && (formData.other_mail || []).some((mail) => !isValidEmail(mail))}
                            onInputChange={setOtherInput}
                            onCommit={(rawValue) => appendEmails("other_mail", rawValue)}
                            onChange={(nextValue) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    other_mail: nextValue,
                                }))
                            }
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} sx={{ fontSize: "10px", textTransform: "none" }}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave} sx={{ minHeight: 30, fontSize: "10px", px: 1.5, textTransform: "none", borderRadius: "7px" }}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Stack>
    );
}

export default ApprovalMAster;
